// Track video playback milestones (25/50/75/100) with the Meta Pixel.
// Works with native <video> elements. For iframe players (YouTube/Vimeo/Wistia)
// the milestone tracking is a no-op — those require their JS APIs.

import { track } from "@/lib/metaPixel";

export function attachVideoMilestones(videoEl, meta = {}) {
  if (!videoEl || videoEl.tagName !== "VIDEO") return () => {};
  const fired = new Set();
  const marks = [0.25, 0.5, 0.75, 1.0];

  const onTime = () => {
    if (!videoEl.duration || Number.isNaN(videoEl.duration)) return;
    const pct = videoEl.currentTime / videoEl.duration;
    for (const m of marks) {
      const key = String(m);
      if (fired.has(key)) continue;
      if (pct >= m - 0.01) {
        fired.add(key);
        track("ViewContent", {
          content_name: `Replay ${Math.round(m * 100)}%`,
          content_category: "webinar_replay",
          ...meta,
        });
      }
    }
  };

  videoEl.addEventListener("timeupdate", onTime);
  return () => videoEl.removeEventListener("timeupdate", onTime);
}
